<template>
  <div id="resetpassword">
    <el-row>
      <el-col :xs="{span:16,offset:4}" :sm="{span:10,offset:7}" :md="{span:8,offset:8}" :lg="{span:6,offset:9}">
        <el-form :model="reset" ref="reset" status-icon>
          <h3 style="text-align:center;">パスワードリセット</h3>
          <el-form-item prop="email" label="メールアドレス"
            :rules="[
              { required: true, message: 'メールアドレスを入力してください', trigger: 'blur' },
              { type: 'email', message: 'メールアドレスの形式が正しくありません', trigger: 'blur,change' }
            ]"
          >
            <el-input placeholder="メールアドレス" v-model="reset.email"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="width:100%" type="primary" @click="resetPassword('reset')">メール送信</el-button>
            <div><el-button type="text" @click="$router.push('/login')">ログインへ</el-button></div>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'resetpassword',
  data () {
    return {
      reset: {
        email: ''
      }
    }
  },
  created () {
    console.log('created:login')
  },
  methods: {
    resetPassword (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.reset)
          var self = this
          this.$http.post('/user/renew', {id: this.reset.email}).then(function (response) {
            console.log(response)
            if (response.result) {
              self.successMessage(response.message)
              setTimeout(function () {
                self.$router.push('/login')
              }, 7000)
            } else {
              self.errorMessage(response.message)
            }
          })
        } else {
          console.log('error resetPassword')
          return false
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/04-pages/Resetpassword.vue